export default function (archetypes) {
  return {
    all: archetypes,

    byArchetypeId (archetypeId) {
      return archetypes.find((type) => type.id === archetypeId)
    },

    findIndexByArchetypeId (archetypeId) {
      return archetypes.findIndex((type) => type.id === archetypeId)
    },

    find (targetVector) {
      let result = null

      if (targetVector?.length < 6 || targetVector.includes(null)) {
        return null
      }

      function calculateCode () {
        let code = ''
        for (let index = 0; index < targetVector.length; index++) {
          code += String((index + 1) * 10 + (targetVector[index] + 1))
        }
        return code
      }

      function calculateWeightedDifference (classification) {
        if (!classification) return null
        const weights = [0.8, 0.3, 1, 0.4, 0.4, 0.8]
        //console.log('weights:', weights)
        const a2 = Object.values(classification)
        //console.log('a2:', a2)
        const res = targetVector.map(function (item, index) {
          return Math.abs(item - a2[index]) * weights[index]
        }).reduce((accumulator, val) => accumulator + val)
        //console.log('res:', res)
        return res
      }

      const code = calculateCode()
      //console.log('code:', code)
      let indexFound = -1
      for (let index = 0; index < archetypes.length; index++) {
        if (code === archetypes[index].matrixCode || archetypes[index].alternativeMatrixCodes.includes(code)) {
          indexFound = index
          break
        }
      }

      if (indexFound === -1) {
        // calculate the weighted difference between the targetVector and the archetypes and write the result in a map
        const diff = archetypes.map(archetype => calculateWeightedDifference(archetype.classification))
        // found the one with the lowest difference
        indexFound = diff.reduce((lowestIndex, element, index, array) => {
          return element != null && element < array[lowestIndex] ? index : lowestIndex
        }, 0)
      }

      result = archetypes[indexFound]
      return result
    }
  }
}
